module.exports = __webpack_public_path__ + "static/media/logo.dcfcd5c4.svg";